import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const LocationSvg = () => (
  <svg width="19" height="19" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.1373 1.00004C14.6211 1.00028 14.1252 1.20107 13.7543 1.56004C13.4992 1.08825 13.1213 0.694189 12.6606 0.419558C12.2 0.144926
      11.6736 -6.10352e-05 11.1373 -6.10352e-05C10.6009 -6.10352e-05 10.0746 0.144926 9.6139 0.419558C9.15322 0.694189 8.77535 1.08825 8.52027
      1.56004C8.23772 1.28771 7.8813 1.10451 7.49539 1.03327C7.10948 0.962033 6.71115 1.0059 6.34999 1.1594C5.98883 1.31291 5.68081 1.56927
      5.46429 1.89656C5.24777 2.22386 5.13232 2.60761 5.13232 3.00004C5.13232 3.39247 5.24777 3.77623 5.46429 4.10352C5.68081 4.43081 5.98883
      4.68717 6.34999 4.84068C6.71115 4.99418 7.10948 5.03805 7.49539 4.96681C7.8813 4.89557 8.23772 4.71238 8.52027 4.44004C8.77535 4.91183
      9.15322 5.30589 9.6139 5.58052C10.0746 5.85516 10.6009 6.00014 11.1373 6.00014C11.6736 6.00014 12.2 5.85516 12.6606 5.58052C13.1213
      5.30589 13.4992 4.91183 13.7543 4.44004C13.9901 4.66735 14.2782 4.83326 14.5931 4.92319C14.9081 5.01311 15.2403 5.0243 15.5606 4.95577C15.881
      4.88724 16.1795 4.74109 16.4301 4.53016C16.6807 4.31923 16.8757 4.04998 16.9979 3.74607C17.12 3.44216 17.1657 3.11289 17.1309 2.78719C17.096
      2.4615 16.9817 2.14935 16.7979 1.87818C16.6142 1.60701 16.3667 1.38512 16.0771 1.232C15.7876 1.07889 15.4648 0.999232 15.1373 1.00004Z"
      fill="currentColor"
    />
    <path
      d="M19.1372 10.0001H4.13721V6.50006C4.13721 6.34482 4.10106 6.1917 4.03163 6.05285C3.96221 5.91399 3.8614 5.79321 3.73721 5.70006L1.73721
      4.20006C1.58864 4.08863 1.41197 4.02078 1.22701 4.0041C1.04205 3.98742 0.856099 4.02258 0.689993 4.10563C0.523888 4.18869 0.384191 4.31635
      0.286556 4.47433C0.188922 4.63231 0.137207 4.81435 0.137207 5.00006V19.0001C0.137207 19.2653 0.242564 19.5196 0.4301 19.7072C0.617637 19.8947
      0.871991 20.0001 1.13721 20.0001H19.1372C19.4024 20.0001 19.6568 19.8947 19.8443 19.7072C20.0319 19.5196 20.1372 19.2653 20.1372 19.0001V11.0001C20.1372
      10.7348 20.0319 10.4805 19.8443 10.293C19.6568 10.1054 19.4024 10.0001 19.1372 10.0001ZM8.13721 18.0001H5.13721V16.0001H8.13721V18.0001ZM8.13721
      14.0001H5.13721V12.0001H8.13721V14.0001ZM13.1372 18.0001H10.1372V16.0001H13.1372V18.0001ZM13.1372 14.0001H10.1372V12.0001H13.1372V14.0001ZM18.1372
      18.0001H15.1372V16.0001H18.1372V18.0001ZM18.1372 14.0001H15.1372V12.0001H18.1372V14.0001Z"
      fill="currentColor"
    />
  </svg>
);

const Location = (props: IIconProps) => <Icon component={LocationSvg} {...props} />;

export default Location;
